import React from 'react';

import { Link } from '@/js/libs/ui';
import { useIdentityRoles } from '@/js/libs/use-auth';

interface UserLinkProps extends React.PropsWithChildren {
  userId?: string;
  className?: string;
}

export const EditUserLink: React.FC<UserLinkProps> = React.memo(function EditUserLink({ className, userId, children }) {
  const { ADMIN } = useIdentityRoles();
  if (ADMIN && userId) {
    return (
      <span className={className}>
        <Link to={`/admin/users/${userId}`}>{children}</Link>
      </span>
    );
  }
  return <span className={className}>{children}</span>;
});
